import { formatDateISO, startOfMonthISO, startOfWeekISO } from '@/lib/diretoriaOficinaFetch';

export type DiretoriaPeriodPreset = 'hoje' | 'semana' | 'mes';

export interface DiretoriaDateRange {
  dataFrom: string;
  dataTo: string;
}

export function resolveComparisonPeriod(dataFrom: string, dataTo: string): DiretoriaDateRange {
  const from = new Date(`${dataFrom}T12:00:00`);
  const to = new Date(`${dataTo}T12:00:00`);
  const days = Math.round((to.getTime() - from.getTime()) / (24 * 60 * 60 * 1000)) + 1;
  const compTo = new Date(from);
  compTo.setDate(compTo.getDate() - 1);
  const compFrom = new Date(compTo);
  compFrom.setDate(compFrom.getDate() - (days - 1));
  return {
    dataFrom: formatDateISO(compFrom),
    dataTo: formatDateISO(compTo),
  };
}

export function getPeriodPresetRange(preset: DiretoriaPeriodPreset): DiretoriaDateRange {
  const today = formatDateISO(new Date());
  if (preset === 'hoje') return { dataFrom: today, dataTo: today };
  if (preset === 'semana') return { dataFrom: startOfWeekISO(), dataTo: today };
  return { dataFrom: startOfMonthISO(), dataTo: today };
}

export function applyPresetWithComparison(preset: DiretoriaPeriodPreset): {
  primary: DiretoriaDateRange;
  comparison: DiretoriaDateRange;
} {
  const primary = getPeriodPresetRange(preset);
  const comparison = resolveComparisonPeriod(primary.dataFrom, primary.dataTo);
  return { primary, comparison };
}

export function validateComparisonRanges(
  primary: DiretoriaDateRange,
  comparison: DiretoriaDateRange
): boolean {
  const iso = /^\d{4}-\d{2}-\d{2}$/;
  if (!iso.test(primary.dataFrom) || !iso.test(primary.dataTo)) return false;
  if (!iso.test(comparison.dataFrom) || !iso.test(comparison.dataTo)) return false;
  return primary.dataFrom <= primary.dataTo && comparison.dataFrom <= comparison.dataTo;
}

export function detectActivePreset(dataFrom: string, dataTo: string): DiretoriaPeriodPreset | null {
  const today = formatDateISO(new Date());
  if (dataFrom === today && dataTo === today) return 'hoje';
  if (dataFrom === startOfWeekISO() && dataTo === today) return 'semana';
  if (dataFrom === startOfMonthISO() && dataTo === today) return 'mes';
  return null;
}

export function formatPeriodLabel(dataFrom: string, dataTo: string): string {
  const fmt = (iso: string) => {
    const [y, m, d] = iso.split('-');
    return `${d}/${m}/${y}`;
  };
  return `${fmt(dataFrom)} — ${fmt(dataTo)}`;
}

export function calcVariacaoPct(atual: number, anterior: number): number | null {
  if (!Number.isFinite(atual) || !Number.isFinite(anterior)) return null;
  if (anterior === 0) return atual === 0 ? 0 : null;
  return ((atual - anterior) / Math.abs(anterior)) * 100;
}

export function formatVariacaoPct(v: number | null | undefined): string {
  if (v == null || !Number.isFinite(v)) return '—';
  const sign = v > 0 ? '+' : '';
  return `${sign}${v.toFixed(1).replace('.', ',')}%`;
}
